import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const CambioCondicionMasivo = () => {
  const [dnis, setDnis] = useState("");
  const [condicionAnterior, setCondicionAnterior] = useState("");
  const [condicionNueva, setCondicionNueva] = useState("");
  const [promocionId, setPromocionId] = useState(4);
  const [descripcion, setDescripcion] = useState("");
  const [resolucion, setResolucion] = useState("");
  const [fechaResolucion, setFechaResolucion] = useState("");

  const usuarioId = 1; // 🔥 Hardcodeado (ideal después sacarlo del token)

  const condiciones = [
    "Convocado",
    "Propedeutico",
    "Excluido",
    "Regular",
    "LiEs",
    "LTB",
    "BAJA",
    "EGRESADO"
  ];

  const handleSubmit = async () => {
    if (!dnis || !condicionNueva || !condicionAnterior) {
      Swal.fire("Error", "Complete los campos obligatorios", "error");
      return;
    }

    if (condicionAnterior === condicionNueva) {
      Swal.fire("Atención", "La condición anterior y nueva no pueden ser iguales", "warning");
      return;
    }

    const dnisFormateados = dnis
      .split(/\n|,/)
      .map(d => d.trim())
      .filter(d => d !== "")
      .join(",");

    const confirmacion = await Swal.fire({
      title: "¿Confirmar cambio masivo?",
      html: `
        <b>Condición anterior:</b> ${condicionAnterior}<br/>
        <b>Condición nueva:</b> ${condicionNueva}<br/>
        <b>Promoción:</b> ${promocionId}<br/><br/>
        Se procesarán los DNIs ingresados.
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, ejecutar",
      cancelButtonText: "Cancelar"
    });

    if (!confirmacion.isConfirmed) return;

    try {
      Swal.fire({
        title: "Procesando...",
        text: "Espere mientras se ejecuta el cambio",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const response = await axios.post(
        "https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/cambiarCondicionMasiva",
        {
          dnis: dnisFormateados,
          condicionAnterior,
          condicionNueva,
          promocionId,
          idUsuario: usuarioId,
          descripcion,
          resolucion,
          fechaResolucion
        }
      );

      const resultados = response.data.resultados || [];

      const exitosos = resultados.filter(r =>
        r.status.toLowerCase().includes("correctamente")
      );

      const fallidos = resultados.filter(r =>
        !r.status.toLowerCase().includes("correctamente")
      );

      Swal.fire({
        title: "Proceso finalizado",
        html: `
          <b>✅ Actualizados:</b> ${exitosos.length}<br/>
          <b>❌ No actualizados:</b> ${fallidos.length}
          <hr/>
          ${fallidos.length > 0
            ? `<b>Detalle errores:</b><br/>
               <div style="max-height:200px; overflow:auto; text-align:left">
               ${fallidos.map(f => `DNI ${f.dni}: ${f.status}`).join("<br/>")}
               </div>`
            : ""}
        `,
        icon: fallidos.length > 0 ? "warning" : "success",
        width: 600
      });

    } catch (error) {
      Swal.fire(
        "Error",
        error.response?.data?.message || "Error en el servidor",
        "error"
      );
    }
  };

  return (
    <div style={{ maxWidth: "600px", margin: "auto" }}>
      <h2>Cambio Masivo de Condición</h2>

      <label>DNIs (separados por coma o línea)</label>
      <textarea
        rows="5"
        className="form-control"
        value={dnis}
        onChange={(e) => setDnis(e.target.value)}
        placeholder="30548471, 40123456 o uno por línea"
      />

      <label className="mt-3">Condición Anterior</label>
      <select
        className="form-control"
        value={condicionAnterior}
        onChange={(e) => setCondicionAnterior(e.target.value)}
      >
        <option value="">Seleccione</option>
        {condiciones.map((c) => (
          <option key={c} value={c}>
            {c}
          </option>
        ))}
      </select>

      <label className="mt-3">Condición Nueva</label>
      <select
        className="form-control"
        value={condicionNueva}
        onChange={(e) => setCondicionNueva(e.target.value)}
      >
        <option value="">Seleccione</option>
        {condiciones.map((c) => (
          <option key={c} value={c}>
            {c}
          </option>
        ))}
      </select>

      <label className="mt-3">Promoción</label>
      <input
        type="number"
        className="form-control"
        value={promocionId}
        onChange={(e) => setPromocionId(e.target.value)}
      />

      <label className="mt-3">Descripción</label>
      <input
        type="text"
        className="form-control"
        value={descripcion}
        onChange={(e) => setDescripcion(e.target.value)}
      />

      <label className="mt-3">Resolución</label>
      <input
        type="text"
        className="form-control"
        value={resolucion}
        onChange={(e) => setResolucion(e.target.value)}
      />

      <label className="mt-3">Fecha Resolución</label>
      <input
        type="date"
        className="form-control"
        value={fechaResolucion}
        onChange={(e) => setFechaResolucion(e.target.value)}
      />

      <button
        className="btn btn-primary mt-4 w-100"
        onClick={handleSubmit}
      >
        Ejecutar Cambio
      </button>
    </div>
  );
};

export default CambioCondicionMasivo;